export default function script_boxAnimation() {
  $(function() {
    const h = window.innerHeight ? window.innerHeight: $(window).height();
    $(window).scroll(function() {
        const value = $(window).scrollTop() + h;
        const box01 = $(".box01").offset().top + 150;
        if(box01 < value ){
          $(".box01").addClass("box01__animation");
        }
    });
  });
}